import script from "./DCLogin.vue?vue&type=script&setup=true&lang=ts"
export * from "./DCLogin.vue?vue&type=script&setup=true&lang=ts"

import "./DCLogin.vue?vue&type=style&index=0&id=39c10f51&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39c10f51"]])

export default __exports__
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCheckbox});
